export default "__VITE_ASSET__1421e701__"